var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AtpveInfo } from "@/components/common/AtpveInfo";
import { EvaluateServiceButton } from "@/components/common/EvaluateServiceButton";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
import { Container } from "@/components/common/Container";
import { PageTitle } from "@/components/common/PageTitle";
import { ServiceInfo, ServiceInfoItem } from "@/components/common/ServiceInfo";
import { useStepperControl } from "@/hooks/useStepperControl";
import GatewayService from "@/services/api/GatewayService";
import { useState } from "react";
import { DialogAtpveDetails } from "./details";
var BREADCRUMB_ITEMS = [
    {
        name: "Página Inicial",
        path: "https://portal.pi.gov.br/detran/",
    },
    {
        name: "Informações do Veículo",
        path: "/",
    },
    {
        name: "Visualizar ATPV-e",
        path: "/",
        current: true,
    },
];
export function Atpve() {
    var service = new GatewayService();
    var _a = useState(false), showAtpve = _a[0], setShowAtpve = _a[1];
    var serviceReturn = useStepperControl().serviceReturn;
    return (_jsxs(Container, { children: [_jsx(Breadcrumbs, { pages: BREADCRUMB_ITEMS }), _jsx(PageTitle, { title: "Inten\u00E7\u00E3o de Venda(ATPV-e)" }), _jsxs("div", __assign({ className: "w-full max-w-[856px] flex flex-col gap-2" }, { children: [_jsx(ServiceInfo, { children: _jsx(ServiceInfoItem, { title: "Inte\u00E7\u00E3o de venda registrada com sucesso!", content: ["Visualize ou faça o download do documento:"], listType: "none" }) }), _jsx(AtpveInfo, { serviceName: "Intenção de Venda(ATPV-e)", data: serviceReturn, handleShowBoleto: setShowAtpve })] })), _jsx(DialogAtpveDetails, { serviceReturn: serviceReturn, service: service, showAtpve: showAtpve, setShowAtpve: setShowAtpve }), _jsx(EvaluateServiceButton, {})] }));
}
